"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteCookie = exports.getCookie = exports.setCookie = void 0;
const cookie_1 = __importDefault(require("cookie"));
const setCookie = (cookieName, cookieValue, expireDays) => {
    if (typeof document === 'undefined') {
        return;
    }
    const date = new Date();
    date.setTime(date.getTime() + expireDays * 24 * 60 * 60 * 1000);
    document.cookie = cookie_1.default.serialize(cookieName, cookieValue, {
        expires: date,
        path: '/'
    });
};
exports.setCookie = setCookie;
const getCookie = (cookieName) => {
    if (typeof document === 'undefined') {
        return;
    }
    try {
        const cookies = cookie_1.default.parse(document.cookie);
        return cookies[cookieName];
    }
    catch (error) {
        console.debug('Error parsing cookies:', error);
        return undefined;
    }
};
exports.getCookie = getCookie;
const deleteCookie = (name) => {
    if (typeof document === 'undefined') {
        return;
    }
    document.cookie = cookie_1.default.serialize(name, '', {
        expires: new Date(0),
        path: '/'
    });
};
exports.deleteCookie = deleteCookie;
//# sourceMappingURL=cookie.js.map